import React from "react"

const Icon = ({ name }) => {
  const SVG = require(`../../../static/images/${name}.inline.svg`)
  return <SVG className={`icon icon--${name}`} />
}

export default Icon